import main from './main'
import device from './device'
import simcard_devices from './simcard_devices'
import simcard_profile from './simcard_profile'
import esim_profile from './esim_profile'
import tickets from './tickets'
import ssh from './ssh'
import interval from './interval'

export default {
  main,
  device,
  simcard_devices,
  simcard_profile,
  esim_profile,
  tickets,
  ssh,
  interval
}
